// extracted by mini-css-extract-plugin
module.exports = {"root":"NotFoundPage_root__305KT"};